import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';
import { addLoginHandlers } from 'dibs-buyer-layout/src/utils/loginHandlers';

import { Error, Loader } from '../shared';
import { getEnvironment } from '../relayModernEnvironment';
import RewardsWrapper from './RewardsWrapper';

export default class RewardsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { userId: getBuyerId(document.cookie) };
    }

    componentDidMount() {
        addLoginHandlers(() => {
            const newUserId = getBuyerId(document.cookie);
            if (newUserId !== this.state.userId) {
                this.setState({
                    userId: newUserId,
                });
            }
        });
    }

    render() {
        const { userId } = this.state;
        const containerProps = this.props;
        const userIds = userId ? [userId] : [];

        return (
            <QueryRenderer
                environment={getEnvironment()}
                query={graphql`
                    query RewardsContainerQuery(
                        $userId: String!
                        $userIds: [String]!
                        $hasUserId: Boolean!
                    ) {
                        viewer {
                            ...RewardsWrapper_viewer
                        }
                    }
                `}
                variables={{
                    userIds,
                    userId: userId || '',
                    hasUserId: !!userId,
                }}
                render={({ props, error }) => {
                    if (props && props.viewer) {
                        return <RewardsWrapper {...containerProps} {...props} />;
                    }

                    if (error) {
                        return <Error />;
                    }

                    return (
                        <div className="rewardsLoader">
                            <Loader />
                        </div>
                    );
                }}
            />
        );
    }
}
